<template>
    <div class="mx-auto w-full mx-auto px-4 mt-16 max-w-md text-center relative">
        <div class="bg-[#bbe0ed] rounded-full top-0 absolute left-[calc(50%-56px)] scale-up-center" />
        <div class="bg-[#bbe0ed] w-28 h-28 rounded-full flex items-center mx-auto justify-center top-0 absolute left-[calc(50%-56px)]">
            <SvgIcon
                icon-name="monitor-white"
                class="text-white w-9 h-9"
            />
        </div>
        <h4 class="pt-40 mb-7">
            授權驗證中
        </h4>
        <p class="font-mono text-base xs:text-lg">
            為確保交易安全，此授權連結有效時間為20分鐘，請於時間範圍內完成授權驗證，銀行授權完成後，請等待約2~3分鐘系統取得資料。
        </p>
        <p class="text-error font-mono text-base xs:text-lg">
            期間請勿關閉此頁面，謝謝。
        </p>
        <!-- <vue-countdown
            v-slot="{ minutes,seconds }"
            :time="time"
            @end="onFinish"
        >
            <span class="countdown font-mono text-base xs:text-lg">
                {{ `為確保交易安全，自授權驗證起10分鐘內有效，本系統將於${minutes}分${seconds}秒後自動停止，請留意時間，謝謝。` }}
            </span>
        </vue-countdown> -->

        <button
            v-if="result?.paymentURL"
            class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem] disabled:text-gray-400 disabled:border-gray-400"
            @click="linkToPaymentURL"
        >
            授權連結
        </button>
    </div>
</template>

<script>
import { computed, onMounted, inject, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';

import { getSearchACH } from '@/apis/aplCatlACH.js';
import { useStore } from 'vuex';
import codeList from '@/json/codeList.js';
import routeName from '@/router/constant.js';
import dialogContent from '@/json/dialogContent';
import { isMobileLogin } from '@/utils/is';
import { useWindowSize } from '@vueuse/core';

export default {
    setup() {
        const $vfm = inject('$vfm');
        const { width, height } = useWindowSize();

        const store = useStore();
        const router = useRouter();
        const result = computed(() => store.state.services.changeItemsResult[`${codeList.ACH}Submit`]);

        // const time = ref(10 * 60 * 1000);
        let setTime = null;
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        goFinish();
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        // const onFinish = () => {
        //     clearInterval(setTime);
        //     modalShow({
        //         title: '很抱歉',
        //         content: '網銀帳密驗證作業已逾時，本交易已自動取消申請，請重新申請保費授權。',
        //         confirmButton: '確認',
        //         closeicon: false,
        //     });
        // };

        const getStarted = () => {
            getSearchACH(result.value.barCode).then(res => {
                const { finish, status } = res.data;
                if (status === '10' || status === '15') {
                    modalShow({
                        title: '很抱歉',
                        content: '網銀帳密驗證作業已逾時，本交易已自動取消申請，請重新申請保費授權。',
                        confirmButton: '確認',
                        closeicon: false,
                    });
                } else if (finish) {
                    goFinish();
                }

                return finish;
            }).catch(() => {
                clearInterval(setTime);
                modalShow(dialogContent.reApply);
                return false;
            });
        };
        const goFinish = () => {
            router.push({ name: routeName.FINISH });
        };
        onMounted(() => {
            getStarted();
            openWindow();
            setTime = setInterval(function () {
                getStarted();
            }, 5000);
        });

        onBeforeUnmount(() => {
            clearInterval(setTime);
        });

        const openWindow = () => {
            const w = width.value * 0.8;
            const h = height.value * 0.8;
            window.open(result.value.paymentURL, 'BankLink', `width=${w}px,height=${h}px`);
        };
        // 打開其它網銀視窗前先確認是不是授權完成
        const linkToPaymentURL = async () => {
            const isFinished = await getStarted();
            if (!isFinished) {
                openWindow();
            }
        };
        return {
            // time,
            linkToPaymentURL,
            // onFinish,
            result
        };
    },
    created() {
        if (!isMobileLogin()) {
            window.addEventListener('beforeunload', this.leaving, { capture: true });
        }
    },
    beforeUnmount() {
        if (!isMobileLogin()) {
            window.removeEventListener('beforeunload', this.leaving, { capture: true });
        }
    },
    methods: {
        leaving(e) {
            e.preventDefault();
            e.returnValue = '要離開網站嗎？系統可能不會儲存您所做的變更。';
            return e;
        },
    },
};
</script>
<style>
.scale-up-center {
    width: 112px;
    height: 112px;

    animation: scale-up-center 1.4s cubic-bezier(0.39, 0.575, 0.565, 1) infinite;
}

@keyframes scale-up-center {
    0% {
        opacity: 1;
        transform: scale(0.8);
    }
    100% {
        opacity: 0;
        transform: scale(1.75);
    }
}
</style>
